import { HtmlHTMLAttributes, useEffect, useState } from 'react';
import { cn } from '@sib/ui';
import {
  CircleCheck,
  ExclamationMarkRounded,
  InfoRounded,
} from '@sib/ui/icons';

interface ShareDialogFormMessageProps
  extends HtmlHTMLAttributes<HTMLDivElement> {
  variant: 'error' | 'warning' | 'success';
  message: string;
  timeout?: number;
}

export const ShareDialogFormMessage = ({
  message,
  variant,
  timeout,
  ...props
}: ShareDialogFormMessageProps) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!timeout) return;
    const timer = setTimeout(() => setVisible(false), timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  useEffect(() => () => setVisible(true), [message]);

  return (
    <div
      {...props}
      className={cn(
        'flex items-center gap-2 opacity-100 transition-all',
        props.className,
        {
          'animate-fade-out': !visible,
        }
      )}
    >
      {variant === 'error' ? (
        <ExclamationMarkRounded className="size-5 min-w-5 text-[#F3486D]" />
      ) : variant === 'warning' ? (
        <InfoRounded className="size-5 min-w-5 text-[#D8B523]" />
      ) : (
        <CircleCheck className="text-secondary size-5 min-w-5" />
      )}
      <p className="text-muted-foreground text-base leading-[18px]">
        {message}
      </p>
    </div>
  );
};
